import { queryOptions } from "@tanstack/react-query";
import { apiClient, orgHeader, unwrap } from "../../../api/client";

const customers = () => apiClient("customers");

/** The plans for the device's product, lowest first (device-plans DP-01 to DP-05). */
export const devicePlansQuery = (orgId: string, deviceId: string) =>
  queryOptions({
    queryKey: ["org", orgId, "/v1/devices/{device_id}/plans", deviceId],
    queryFn: () =>
      unwrap(
        customers().GET("/v1/devices/{device_id}/plans", {
          params: { path: { device_id: deviceId }, header: orgHeader(orgId) },
        }),
      ).then((r) => r.items),
    staleTime: 5 * 60_000,
  });

/** Ask Creavision for a higher plan (DP-20 to DP-24). */
export function requestUpgrade(orgId: string, deviceId: string, planId: string, note: string) {
  return unwrap(
    customers().POST("/v1/devices/{device_id}/upgrade-requests", {
      params: { path: { device_id: deviceId }, header: orgHeader(orgId) },
      body: { plan_id: planId, ...(note.trim() ? { note: note.trim() } : {}) },
    }),
  );
}
